/** JSON for an inline <script>: `<`, `>`, `&`, U+2028 and U+2029 are escaped. Mirrors scripts/safe-json.mjs. */
export const safeJson = (value: unknown): string => JSON.stringify(value)
  .replace(/</g, '\\u003c')
  .replace(/>/g, '\\u003e')
  .replace(/&/g, '\\u0026')
  .replace(/\u2028/g, '\\u2028')
  .replace(/\u2029/g, '\\u2029');
